export default "__VITE_ASSET__DMpGqLed__"